import PropTypes from 'prop-types';

import Doctolib from "../../assets/media/partners/doctolib.png"
// import Livi from "../../assets/media/partners/livi.png"
import Maiia from "../../assets/media/partners/maiia.png"
import keldoc from "../../assets/media/partners/keldoc.png"
import Gps_sante from "../../assets/media/partners/gps-sante.png"
import MonDoc from "../../assets/media/partners/avec-mondoc.png"

import './partnersLink.scss';
import { prepareUrlForSearch } from '../../utils/utils';

export interface propsInterfaces {
  handleClick: () => void
}

export const PartnersLink = (props: propsInterfaces) => {
  const {handleClick } = props

  return (
    <div className="flex flex-row gap-4 my-5 justify-center">
        <a 
          className="px-2 py-2 md:px-4 md:py-4 btn rounded-lg md:w-auto" 
          onClick={() => handleClick()} 
          href={prepareUrlForSearch("Médecin traitant", "Doctolib")} 
          rel="noreferrer" 
          target="_blank"
        >
          <img src={Doctolib} alt="Doctolib" className={`w-[120px]`} />
        </a>
        {/* <a 
          className="px-4 py-4 btn rounded-lg w-full md:w-auto" 
          onClick={() => handleClick()} 
          href="https://app.adjust.com/1e83eqis?redirect=https%3A%2F%2Fapp.livi.fr%2Flogin%3Fredirect%3D%252Fapp-link%252Fall" 
          rel="noreferrer" 
          target="_blank"
        >
          <img src={Livi} alt="Livi" className={`h-[40px]`} />
        </a> */}
        <a 
          className="px-2 py-2 md:px-4 md:py-4 btn rounded-lg md:w-auto"  
          onClick={() => handleClick()} 
          href={prepareUrlForSearch("Médecin traitant", "Maiia")} 
          rel="noreferrer" 
          target="_blank"
        >
          <img src={Maiia} alt="Maiia" className={`w-[100px]`} />
        </a>
        <a 
          className="px-2 py-2 md:px-4 md:py-4 btn rounded-lg md:w-auto"  
          onClick={() => handleClick()} 
          href={prepareUrlForSearch("Médecin traitant", "KelDoc")} 
          rel="noreferrer" 
          target="_blank"
        >
          <img src={keldoc} alt="keldoc" className={`w-[120px]`} />
        </a>
        {/* <a 
          className="px-4 py-4 btn rounded-lg w-full md:w-auto"  
          onClick={() => handleClick()} 
          href="https://www.gpssante.fr/" rel=
          "noreferrer" target="_
          blank"
        >
          <img src={Gps_sante} alt="Gps_sante" className={`h-[30px]`} />
        </a>
        <a 
          className="px-4 py-4 btn rounded-lg w-full md:w-auto"  
          onClick={() => handleClick()} 
          href="https://www.avecmondoc.com/accueil" 
          rel="noreferrer" 
          target="_blank"
        >
          <img src={MonDoc} alt="avec-mondoc" className={`h-[30px]`} />
        </a> */}
    </div>
  )
}

PartnersLink.propTypes = {
  handleClick: PropTypes.func,
};

PartnersLink.defaultProps = {
  handleClick: () => null
};